import React, { Fragment } from "react";
import { withStyles, Link, IconButton, Tooltip } from "@material-ui/core";
import constants from "../../../../../../appConstants";
import { TimeRangeEditor } from "../../../../../dataGrid/cellEditors";
import EventBusyOutlined from "@material-ui/icons/EventBusyOutlined";
import capitalize from "lodash/capitalize";

export const closedDayTime = "00:00 - 00:00";

const styles = (theme) => ({
  addHoursStyle: {
    color: theme.HeaderSelectedText,
    fontSize: theme.textFontSize,
  },
  dayNameStyle: {
    minHeight: 40,
    display: "flex",
    alignItems: "center",
  },
  timeRangeEditorStyle: {
    marginBottom: 10,
    marginLeft: -5,
  },
  receivingHoursError: {
    color: theme.ErrorMessageColor,
  },
  closeIcon: {
    "&:hover": {
      color: theme.error,
    },
    color: theme.iconColor,
  },
});

export const DateTime = (props) => {
  const updateTime = (time) => {
    if (time !== "Invalid_Time" && props.time !== time) {
      props.updateTime(props.index, time);
    }
  };
  return (
    <TimeRangeEditor
      DATETYPE={constants.DATETYPES.TIME}
      isTimeInterval={true}
      value={props.time}
      onChange={updateTime}
      componentSpecificProps={{
        isClosedDay: props.isClosedDay,
        startLabel: "Opens at",
        endLabel: "Closes at",
        isInputBorderRequired: false,
        autoFocus: props.autoFocus
      }}
    />
  );
};

const ReceivingHours = (props) => {
  const { dayName, dayIndex, hours, updateHours, errors, classes } = props;
  const markDayAsClosed = () => {
    updateHours(dayName, [closedDayTime]);
  };

  const updateTime = (index, time) => {
    if (time === closedDayTime) {
      markDayAsClosed();
      return;
    }
    const newHours = hours.slice();
    newHours[index] = time;
    updateHours(dayName, newHours);
  };

  const addHours = () => {
    updateHours(dayName, [...hours, ""]);
  };
  const isClosedDay = hours.length === 1 && hours[0] === closedDayTime;

  return (
    <Fragment>
      <div className={classes.dayNameStyle}>
        {capitalize(dayName)}
        {!isClosedDay ? (
          <Tooltip title="Mark Closed">
            <IconButton
              onClick={markDayAsClosed}
              classes={{ root: classes.closeIcon }}
              id="markClosed"
            >
              <EventBusyOutlined />
            </IconButton>
          </Tooltip>
        ) : null}
      </div>
      {hours.map((hour, index) => (
        <div key={index}>
          <div className={classes.timeRangeEditorStyle}>
            <DateTime
              isClosedDay={isClosedDay}
              time={hour}
              index={index}
              key={`${dayName}_${isClosedDay}`}
              updateTime={updateTime}
              autoFocus={dayIndex === 0}
            />
          </div>
          {errors?.[index] ? (
            <div className={classes.receivingHoursError}>{errors?.[index]}</div>
          ) : null}
        </div>
      ))}
      {hours.length <= 1 && !isClosedDay && (
        <Link
          className={classes.addHoursStyle}
          color="inherit"
          component="button"
          variant="h3"
          onClick={addHours}
        >
          + Add Hours
        </Link>
      )}
    </Fragment>
  );
};
export default withStyles(styles)(ReceivingHours);
